import { Button, Col, Table, TableActionBarRow } from "melco-ui";
import { useTranslation } from "react-i18next";

import { useState } from "react";
//import styled from "styled-components";
import { ReportsDownloadListFilter } from "./ReportsDownloadListFilter";
import { useReports } from "../../hooks/reports/useReports";
import { ReportDownloadDetailDrawer } from "./drawer/Detail/ReportDownloadDetailDrawer";
import { TrackingTrackingModelsAnalyticsDownloadDailySummary } from "melco-shared-logic";
import { UserReportDownloadButton } from "./UserReportDownloadButton";
import dayjs from "dayjs";
import { ReportsDownloadListFiltersType } from "../../hooks/reports/reportsListFilterType";

// const Right = styled(Space)`
//   display: flex;
//   flex-direction: column;
//   align-items: flex-end;
// `;

export const ReportsDownloadBillingList: React.FC = () => {
  const {
    isLoading,
    isFetching,
    data,
    isPreviousData,
    errorComponent,
    onTableConfigChange,

    filtersChange,
  } = useReports();
  // const runTable = useLicences();
  const { t } = useTranslation();
  const [selectedRowType, setSelectedRowType] = useState("");
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState<string | undefined>("");
  const [selectedRowProductCode, setSelectedRowProductCode] = useState<
    string | undefined
  >("");
  const [reportsFilter, setReportsFilter] = useState<
    ReportsDownloadListFiltersType | undefined
  >();

  const columns = [
    {
      title: t("reports.table.column.user_name"),
      key: "user_name",
      dataIndex: "user_name",
      //sorter: true,
      width: 40,
    },
    {
      title: t("reports.table.column.first_name"),
      key: "first_name",
      dataIndex: "first_name",
      // sorter: true,
      width: 25,
    },
    {
      title: t("reports.table.column.last_name"),
      key: "last_name",
      dataIndex: "last_name",
      // sorter: true,
      width: 25,
    },
    {
      title: t("reports.table.column.melco_customer_id"),
      key: "melco_customer_id",
      dataIndex: "melco_customer_id",
      // sorter: true,
      width: 25,
    },
    {
      title: t("reports.table.column.product_code"),
      key: "product_code",
      dataIndex: "product_code",
      // sorter: true,
      width: 25,
    },
    {
      title: t("reports.table.column.type"),
      key: "type",
      dataIndex: "type",
      // sorter: true,
      width: 25,
    },
    {
      title: t("reports.table.column.unique_downloads"),
      key: "unique_downloads",
      dataIndex: "unique_downloads",
      //  sorter: true,
      width: 35,
    },
    {
      title: t("reports.table.column.total_downloads"),
      key: "total_downloads",
      dataIndex: "total_downloads",
      //sorter: true,
      width: 30,
    },
    {
      title: t("reports.table.column.details"),
      key: "Details",
      //  dataIndex: "serial_number",
      // sorter: true,
      width: 30,
      render: (rowObj: TrackingTrackingModelsAnalyticsDownloadDailySummary) => (
        <Button
          type="primary"
          onClick={() => {
            console.log("onClick");
            setSelectedUserId(rowObj.id ?? "");
            setSelectedRowProductCode(rowObj.product_code ?? "");
            setDrawerOpen(true);
            setSelectedRowType(rowObj.type ?? "")
            console.log("OPEN");
            // setLicenseSerialNumberToCancel(rowObj.serial_number);
          }}
        >
          {t("reports.basic.detail")}
        </Button>
      ),
    },
    {
      title: t("reports.table.column.export"),
      key: "Export",
      //  dataIndex: "serial_number",
      //  sorter: true,
      width: 30,
      render: (rowObj: TrackingTrackingModelsAnalyticsDownloadDailySummary) => (
        <div>
          <UserReportDownloadButton
            productCode={rowObj?.product_code ?? ""}
            userId={rowObj.id ?? undefined}
            filename={
              rowObj?.product_code +
              "- Billing - " +
              rowObj.first_name +
              " " +
              rowObj.last_name +
              reportsFilter?.startTimeStamp?.toLocaleDateString() +
              " - " +
              reportsFilter?.endTimeStamp?.toLocaleDateString()
            }
            dateRange={{
              start: dayjs(reportsFilter?.startTimeStamp),
              end: dayjs(reportsFilter?.endTimeStamp),
            }}
          />
        </div>
      ),
    },
  ];

  const filtersChangeCallback = (
    filters: ReportsDownloadListFiltersType | undefined
  ) => {
    setReportsFilter(filters);
    filtersChange(filters);
  };

  const setDrawerAction = (action: boolean) => {
    setDrawerOpen(action);
  };

  return (
    <>
      <TableActionBarRow>
        <div></div>
        <Col xs={24} xl={20}>
          <ReportsDownloadListFilter onFiltersChange={filtersChangeCallback} />
        </Col>
      </TableActionBarRow>
      <Table
        showSorterTooltip={false}
        sticky
        loading={isPreviousData ? isFetching : isLoading}
        dataSource={data?.tableData}
        columns={columns}
        onChange={onTableConfigChange}
        // pagination={pagination}
        pagination={false}
        rowKey="serial_number"
        // rowSelection={rowSelection}
        // onRow={onRow}
        noDataMessage={t("reports.basic.no_reports_message")}
        errorComponent={errorComponent}
      //scroll={{ x: 1700 }}
      />

      <ReportDownloadDetailDrawer
        isDrawerOpen={isDrawerOpen}
        setDrawerOpen={setDrawerAction}
        selectedUserId={selectedUserId ?? ""}
        reportsRawData={data?.rawData}
        selectedRowProductCode={selectedRowProductCode ?? ""}
        selectedRowType={selectedRowType ?? ""}
      />
    </>
  );
};
